import { Box, Typography, Switch } from "@mui/material";

const YoutubeToggle = ({ label, value, onChange }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: 300,
        mb: 2,
      }}
    >
      <Typography>{label}</Typography>
      <Switch checked={value} onChange={() => onChange(!value)} />
    </Box>
  );
};

export default YoutubeToggle;
